/**
 * Chemins des ecrans de comptes.
 *
 * Module **pur**, sans JSX ni React : il est importe aussi bien par les ecrans
 * que par le menu (`src/ui/navigation.ts`), qui doit rester testable sans monter
 * React Admin. Ecrire le chemin en clair aux deux endroits reviendrait a le
 * maintenir deux fois, et une entree de menu qui pointe a cote ne se voit qu'a
 * l'usage.
 *
 * Liste et fiche forment un ecran liste + detail (`MasterDetail`) : une seule
 * route `/accounts/users/*` le monte, et la fiche ouverte (`/accounts/users/<id>`)
 * vit dans l'URL — deux routes distinctes demonteraient la liste, ses filtres et
 * sa position, a chaque ouverture. Le registre de navigation pointe la **base**.
 */

export const ACCOUNTS_USERS_PATH = '/accounts/users';

export const ACCOUNTS_USERS_ROUTE = `${ACCOUNTS_USERS_PATH}/*`;

export const accountDetailPath = (userId: string): string =>
  `${ACCOUNTS_USERS_PATH}/${encodeURIComponent(userId)}`;
